import { createSelector } from 'reselect';

import {
  State,
  TransferNotification,
  Notification,
  NotificationStore,
} from '@wetransfer/transfer/store/types';

export const selectNotification = (state: State): State['notification'] =>
  state.notification;

const transferNotificationSelector = createSelector(
  selectNotification,
  (notification) => notification.transfer
);

export const getTransferNotification = createSelector(
  transferNotificationSelector,
  (transferNotification): TransferNotification | undefined => {
    return transferNotification?.text !== undefined &&
      transferNotification?.date !== undefined
      ? (transferNotification as TransferNotification)
      : undefined;
  }
);

export const getPanelNotification = createSelector(
  selectNotification,
  (notification: NotificationStore): Notification => notification.panel
);
